
import { EMPTY_PARTICIPATION_RATE_SEARCH_CRITERIA } from "domain/entity/ParticipationRate/ParticipationRateSearchCriteria";
import { getDefaultBuConfig } from "domain/repository/apiUtil";
import moment from "moment";
import { useParticipationRateMaintenanceVM } from "presentation/hook/ParticipationRate/useParticipationRateMaintenanceVM";
import { useParticipationRateMaintenanceTracked } from "presentation/store/ParticipationRate/ParticipationRateMaintenanceProvider";
import { useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import { ParticipationRateMaintenanceFormPanel } from "./ParticipationRateMaintenanceFormPanel";
import ParticipationRateSearchPanel from "./ParticipationRateSearchPanel";
import ParticipationRateTablePanel from "./ParticipationRateTablePanel";

export const ParticipationRateMaintenance: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [participationRateState] = useParticipationRateMaintenanceTracked();
    const participationRateVM = useParticipationRateMaintenanceVM();
    const { isBackMaster, isShowEditPanel, isShowSearchPanel } = participationRateState;


    useEffect(() => {
        const initialScreen = async () => {
            setIsLoading(true);
            try {
                let newSearchCriteria = { ...EMPTY_PARTICIPATION_RATE_SEARCH_CRITERIA }
                newSearchCriteria = {
                    ...newSearchCriteria,
                    etdFrom: moment().subtract(getDefaultBuConfig("REACT_APP_SEARCH_DATA_DEFAULT_DATE_RANGE"), "days").startOf("day").toDate(),
                    etdTo: moment().endOf("day").toDate(),
                };
                const results = await Promise.allSettled([
                    participationRateVM.loadDropdownOption(),
                    participationRateVM.onSearch(false, newSearchCriteria),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then(() => {
            setIsLoading(false)
        }).catch(error => {
            setIsLoading(false)
        });

    }, [isBackMaster, participationRateVM])


    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${isShowSearchPanel ? '' : ' im-hide-side-form-draggable'}`}>
            {!(isShowEditPanel) &&
                <SliderPanel
                    isOpen={true}
                    draggable={false}
                    leftSectionWidth={isShowSearchPanel ? "30%" : "0%"}
                    rightSectionWidth={isShowSearchPanel ? "70%" : "100%"}
                    leftChildren={<ParticipationRateSearchPanel />}
                    rightChildren={<ParticipationRateTablePanel />}
                />}
            {(isShowEditPanel) &&
                <SliderPanel
                    isOpen={true}
                    draggable={false}
                    leftSectionWidth={"100%"}
                    rightSectionWidth={"0%"}
                    leftChildren={<ParticipationRateMaintenanceFormPanel />}
                />}
        </div>
    </>
}
